import React from "react";
import { graphql } from "gatsby";

import Layout from "../components/ui/Layout";
import Header from "../components/ui/Header";
import Section from "../components/ui/Section";
import Container from "../components/ui/Container";
import ArticleCard from "../components/ui/ArticleCard";
import Seo from "../components/ui/Seo";

const GuideIndex = ({ data, location }) => {
  return (
    <Layout>
      <Seo
        title="Guide on how to buy a house in New Zealand"
        description="Everything you need to know about purchasing a new property in NZ. Updated frequently. Read more here..."
        url={location.href}
      />

      <Header title="Guides" subTitle="" />

      <Section bg="lightGrey">
        <Container>
          {data.allDatoCmsBlog.edges.map(({ node }) => {
            const image = node.headerImage || {};

            return (
              <ArticleCard
                width={300}
                slug={`/guide/${node.slug}`}
                title={node.title}
                subTitle={node.subtitle}
                category={node.category.title}
                image={image}
              />
            );
          })}
        </Container>
      </Section>
    </Layout>
  );
};

export default GuideIndex;

export const query = graphql`
  query GuideIndexQuery {
    allDatoCmsBlog {
      edges {
        node {
          title
          subtitle
          category {
            title
          }
          slug

          headerImage {
            fluid(
              maxWidth: 600
              maxHeight: 400
              imgixParams: { fm: "jpg", auto: "compress" }
            ) {
              ...GatsbyDatoCmsFluid
            }
          }
        }
      }
    }
  }
`;
